









































import { getMessageById } from '@/utils/message';
import { convertStr2Num } from '@/utils/utils';
import Vue from 'vue';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default Vue.extend<any, any, any, any>({
  name: 'CtrlNumTxt',
  props: {
    // property [label] の初期値は ['']（値無し）とする
    label: { required: false, type: String, default: '' },
    required: { required: false, type: Boolean, default: false },
    // property [intLength] を追加する(整数の最大桁数 ※ 符号と","を含まない)
    intLength: { required: false, type: Number },
    // property [decLength] を追加する(小数の最大桁数 ※ "." を含まない)。0の場合は"."の入力を禁止する
    decLength: { required: false, type: Number, default: 0 },
    // property [minus] を追加する(false の場合、"-"の入力を禁止する)
    minus: { required: false, type: Boolean, default: true },
    // property [zeroDisp] を追加して、これが true で 未入力の場合 "0" を常に表示する(小数2桁の場合は 0.00 となる)
    zeroDisp: { required: false, type: Boolean, default: true },
    value: { required: false, type: [String, Number], default: '' },
    comma: { required: false, type: Boolean, default: true },
    textAlign: { required: false, type: String, default: 'right' },
    isNoData: { required: false, default: false },
    labelAlign: { required: false, type: String, default: 'left' },
  },

  data() {
    return {
      textValue: '',
      rules: {
        required: (value: string) => !!value || getMessageById('KI_W007'),
        noData: null,
      },
      isOutFocus: false,
      style: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
    };
  },

  computed: {
    inputRules() {
      // 必須チェックを判断
      // if (this.required || (this.required && !this.isNoData)) {
      //   return [this.rules.required];
      // } else if (!this.textValue) {
      //   return [];
      // } else if (this.required && this.isNoData) {
      //   return [this.rules.required, this.rules.noData];
      // } else if (this.isNoData) {
      //   return [this.rules.noData];
      // } else {
      //   return [];
      // }

      if (this.required && this.isNoData && this.isOutFocus) {
        return [this.rules.required, this.rules.noData];
      } else if (this.required || (this.required && !this.isNoData)) {
        return [this.rules.required];
      } else if (!this.textValue) {
        return [];
      } else if (this.isNoData && this.isOutFocus) {
        return [this.rules.noData];
      } else {
        return [];
      }

      // if (!this.textValue) {
      //   return [];
      // } else {
      //   if (this.required && this.isNoData) {
      //     return [this.rules.required, this.rules.noData];
      //   } else if (this.required || (this.required && !this.isNoData)) {
      //     return [this.rules.required];
      //   } else if (this.isNoData) {
      //     return [this.rules.noData];
      //   } else {
      //     return [];
      //   }
      // }
    },

    textColor() {
      return convertStr2Num(this.textValue) < 0 ? 'text-red' : '';
    },
    readonly() {
      return (
        'readonly' in this.$attrs &&
        (this.$attrs.readonly === '' ||
          this.$attrs.readonly === 'true' ||
          this.$attrs.readonly)
      );
    },
  },

  methods: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    format(value: any) {
      let newValue = '';
      let clearedValue = value.replace(/[^0-9.]/g, '');
      const myArray = clearedValue.split('.');
      const formattedValue = myArray[0].substr(0, this.intLength);
      // 接頭で "." が入力されたら、"0." に変換する
      let prefixPart = '0';

      if (formattedValue != '') {
        // first-letterが0の場合、 012345 -> 12345 変換
        prefixPart = `${parseInt(formattedValue)}`;
      }
      let subPart = '';
      // "." は複数入力禁止
      for (let i = 1; i < myArray.length; i++) {
        if (myArray[i] != '') {
          subPart = subPart + myArray[i];
          // break;
        }
      }
      if (subPart !== '') {
        newValue = [prefixPart, subPart].join('.');
      } else {
        newValue = prefixPart;
      }
      // 入力値をフォーマットする
      // 小数点以下が存在する場合
      if (newValue.split('.').length > 1) {
        // 小数点前後で分割する
        const myArray = newValue.split('.');
        // 小数点以下の表示数値が設定されている場合
        if (this.decLength != 0) {
          let decimalPart = myArray[1].substring(0, this.decLength);
          decimalPart = decimalPart.replace(/0+$/, ''); // 末尾のゼロを削除する
          const zeroSpaceAfterDecimalPart = this.decLength - decimalPart.length;
          // 0を表示させる かつ 小数点以下の桁数が小数点より少ない場合
          if (this.zeroDisp && decimalPart.length < this.decLength) {
            for (let i = 0; i < zeroSpaceAfterDecimalPart; i++) {
              decimalPart = decimalPart + '0';
            }
          }
          // 小数点以下が存在する場合
          if (decimalPart !== '' && decimalPart.length > 0) {
            newValue =
              prefixPart.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') +
              '.' +
              decimalPart;
            // 小数点以下が存在しない場合
          } else {
            newValue = prefixPart.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
          }
          // 小数点以下の表示数値が設定されていない場合
        } else {
          newValue = prefixPart.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        }
        // 小数点以下が存在しない場合
      } else {
        // 小数点以下の表示数値が設定されている場合
        newValue = newValue.substring(0, this.intLength);
        newValue = newValue.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        // zeroDisp かつ 数値が 0 のとき
        if (this.zeroDisp) {
          if (this.decLength > 0) {
            newValue = newValue + '.';
            for (let i = 0; i < this.decLength; i++) {
              newValue += '0';
            }
          }
        }
      }
      if (
        ((this.minus && this.minus === true) || this.readonly) &&
        value.indexOf('-') === 0 &&
        newValue !== '0'
      ) {
        // property [minus] を追加する(false の場合、"-"の入力を禁止する)
        newValue = '-' + newValue;
      }
      if (newValue === '0' && !this.zeroDisp) newValue = '';
      return newValue;
    },
    // 入力値を変更時、フォーマットする
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onBlur(event: any) {
      this.isOutFocus = true;
      if (this.readonly) {
        return;
      }
      const value = event.target.value;
      // 入力可能文字は、数値と "-" と "." のみとする
      // "-" は接頭以外では入力禁止
      let formatValue = this.format(value);
      let realValue = formatValue.replaceAll(',', '');

      const self = this;
      this.$nextTick(() => {
        if (this.comma) self.textValue = formatValue;
        else self.textValue = realValue;
        self.$emit('input', realValue);
      });
    },
    onFocus(focusEvent: any) {
      this.isOutFocus = false;
      // High prioty
      if (this.readonly) {
        return;
      }
      this.textValue = this.textValue.replaceAll(',', '');
      this.$nextTick(function () {
        focusEvent.target.select();
      });
    },
    defaultValue() {
      let value = '';
      // property [zeroDisp] を追加して、これが true で 未入力の場合 "0" を常に表示する(小数2桁の場合は 0.00 となる)
      if (this.zeroDisp && this.value.length <= 0) {
        value = '0';
        if (this.decLength > 0) {
          value = '0.';
          for (let i = 0; i < this.decLength; i++) {
            value += '0';
          }
        }
      } else {
        if (+this.value) value = this.value;
      }

      return value;
    },
  },
  watch: {
    value(newVal) {
      let formatValue = this.format((newVal || 0).toString());
      let realValue = formatValue.replaceAll(',', '');
      if (this.comma) this.textValue = formatValue;
      else this.textValue = realValue;
    },
    isNoData(newVal) {
      if (newVal) {
        this.rules.noData = '';
      } else {
        this.rules.noData = true;
      }
    },
  },
  mounted() {
    // テキスト値を変更時、フォーマットする
    let formatValue = this.format(this.defaultValue().toString());
    let realValue = formatValue.replaceAll(',', '');
    if (this.comma) this.textValue = formatValue;
    else this.textValue = realValue;
    this.$emit('input', this.textValue);
  },
});
